// extracted by mini-css-extract-plugin
export default {"number":"ModalWalkInReg_number__XrwwV","desc":"ModalWalkInReg_desc__KuxZw"};